module.exports = __webpack_public_path__ + "static/media/QDC_Logo.52a9b71d.png";